import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useCheckoutFlowStore } from "../store/useCheckoutFlowStore";
import { CheckoutStep } from "../types/common";
import { encodeStepToUrl } from "../utils/step.utils";
import { useCart } from "./useCart";
import { useAuthStore } from "../store/useAuthStore";
import { useCartStore } from "../store/useCartStore";
import { useAlertDialogStore } from "../store/useAlertDialogStore";

const getCreateOrderErrorMessage = (err: any) =>
  err?.response?.data?.message ||
  err?.message ||
  "Failed to create order";

export const useSyncStep = () => {
  const navigate = useNavigate();
  const goToStep = useCheckoutFlowStore((state) => state.goToStep);
  const { user } = useAuthStore();
  const { addToCartAsync } = useCart(user?.cusId || "");
  const localCart = useCartStore((state) => state.cartItems);
  const showAlert = useAlertDialogStore((state) => state.showAlert);

  return useCallback(
    async (step: CheckoutStep) => {
      if (step === "payment") {
        try {
          await addToCartAsync(localCart);
        } catch (err: any) {
          showAlert(getCreateOrderErrorMessage(err));
          return false;
        }
      }

      goToStep(step);

      if (step === "select") {
        navigate("/", { replace: true });
      } else {
        const search = encodeStepToUrl(step);
        navigate(`/checkout${search}`, { replace: true });
      }
      return true;
    },
    [addToCartAsync, localCart, goToStep, navigate, showAlert],
  );
};
